import {EGameMode, gameModeState, sceneState} from '@/domains/Store/atoms'
import FrameStore from '@/domains/Store/FrameStore'
import {EScene} from '@/types/scene.types'
import {useSetAtom} from 'jotai'
import {useCallback} from 'react'

const fStore = new FrameStore()

export const useStartSinglePlayerTrigger = () => {
  const setGameMode = useSetAtom(gameModeState)
  const setScene = useSetAtom(sceneState)

  const startSinglePlayer = useCallback(() => {
    setScene(EScene.LOBBY)
    setGameMode(EGameMode.SINGLE_PLAYER)
    fStore.setGameMode(EGameMode.SINGLE_PLAYER)
  }, [])

  return {
    startSinglePlayer,
  }
}
